import s from './PagePlaceholder.module.css';

export default function PagePlaceholder() {
  return (
    <svg
      className={s.svg}
      xmlns="http://www.w3.org/2000/svg"
      width="280.5px"
      height="280px"
      viewBox="0 0 131.5 131"
    >
      <path
        fill="#171b21"
        d="M81.01,95.84c5.7,0,10.33-4.63,10.33-10.33c0-5.71-4.63-10.33-10.33-10.33
					c-5.71,0-10.34,4.62-10.34,10.33C70.67,91.21,75.3,95.84,81.01,95.84z M89.54,68.84c5.71,0,10.34-4.63,10.34-10.32
					c0-5.71-4.63-10.33-10.34-10.33c-5.7,0-10.33,4.62-10.33,10.33C79.21,64.21,83.84,68.84,89.54,68.84z M76.08,41.67
					c0-5.71-4.62-10.34-10.33-10.34s-10.33,4.63-10.33,10.34S60.04,52,65.75,52S76.08,47.38,76.08,41.67z M52.13,96.01
					c5.7,0,10.33-4.609,10.33-10.33c0-5.71-4.63-10.319-10.33-10.319c-5.71,0-10.34,4.609-10.34,10.319
					C41.79,91.4,46.42,96.01,52.13,96.01z M62.08,72l10.67-6.33l-10.67-6.34V72z M32.46,58.35c0,5.7,4.62,10.33,10.33,10.33
					s10.34-4.63,10.34-10.33c0-5.7-4.63-10.33-10.34-10.33S32.46,52.65,32.46,58.35z M65.75,107.67c-23,0-41.67-18.66-41.67-41.67
					c0-23.02,18.67-41.67,41.67-41.67c23.01,0,41.67,18.65,41.67,41.67C107.42,89.01,88.76,107.67,65.75,107.67z"
      />
      <path
        className={s.ring1}
        fill="none"
        stroke="#171b21"
        strokeWidth="4"
        strokeMiterlimit="10"
        d="M65.75,14.67C37.4,14.67,14.42,37.65,14.42,66
					c0,28.34,22.98,51.33,51.33,51.33c28.35,0,51.33-22.99,51.33-51.33"
      />
      <path
        className={s.ring2}
        fill="none"
        stroke="#171b21"
        strokeWidth="4"
        strokeMiterlimit="10"
        d="M65.75,128.33c34.42,0,62.33-27.91,62.33-62.33
					S100.17,3.67,65.75,3.67c-34.31,0-62.16,27.73-62.33,62"
      />
    </svg>
  );
}
